$(document).ready(function () {
    const metricsURL = "https://yq6afdofq7.execute-api.us-west-2.amazonaws.com";
    const firstOpen = "user_flrst_v2";
    let requestSent = {};

    function handleScroll() {
        if (!requestSent['scroll'] && $(window).scrollTop() > $(window).height() / 2) {
            sendMetric('/m6');
            requestSent['scroll'] = true;
            $(window).off('scroll', handleScroll);
        }
    }
    function sendMetric(path) {
        return $.ajax({
            url: metricsURL + path,
            type: 'POST',
            timeout: 5000,
            contentType: 'application/json',
            error: function (xhr, status, error) {
                console.error('Metrics AJAX request failed:', error);
            }
        });
    }

    function handleClick(type, path, href) {
        if (!requestSent[type]) {
            sendMetric(path).then(function () {
                requestSent[type] = true;
                // Redirect to the new location after the AJAX request is successful.
                if (href) {
                    window.location.href = href;
                }

            });
        }
        else {
            if (href) {
                window.location.href = href;
            }
        }
    }

    if (!localStorage.getItem(firstOpen)) {
        localStorage.setItem(firstOpen, 'true');

        sendMetric('/m1')

        $(window).on('scroll', handleScroll);

        $(document).on('click', '.js-sm', function (e) {
            console.log('click')
            const type = $(this).data('m');
            const href = $(this).attr('href');

            if(href){
                e.preventDefault();
            }


            const metricsMap = {
                'create': '/m2',
                'menu': '/m3',
                'stories': '/m4',
                's-create': '/m5',
                'bstories': '/m7'
            };

            if (metricsMap[type]) {
                handleClick(type, metricsMap[type],href);
            }

        });
    }

});
